export default __webpack_public_path__ + "static/paragraph-c215eedd0a0e3a3b34456d9140033029.jpeg";